// /src/components/CartButton.jsx
import React from "react";
import { useTranslation } from "react-i18next";

export default function CartButton({ count, onClick, className }) {
  const { t } = useTranslation("common");
  const cartTitle = t("cart.title");
  if (!count || count <= 0) return null;
  return (
    <button
      className={className}
      onClick={onClick}
      title={cartTitle}
      style={{
        position: "relative",
        background: "#fff",
        color: "#006e45",
        border: "2px solid #00723a",
        fontWeight: 700,
        fontSize: 17,
        borderRadius: 24,
        padding: "8px 20px 8px 18px",
        minWidth: 130,
        display: "flex",
        alignItems: "center",
        gap: 10,
        cursor: "pointer",
        boxShadow: "0 2px 8px #006e4520"
      }}
    >
      {cartTitle}
      <span
        style={{
          width: 9,
          height: 9,
          borderRadius: "50%",
          background: "rgb(0,110,69)",
          display: "inline-block",
          margin: "0 7px 0 2px",
          border: "1px solid rgb(0,110,69)",
          verticalAlign: "middle"
        }}
      />
      <span style={{ fontWeight: 800, fontSize: 17, display: "inline-block", width: 18, textAlign: "right" }}>
        {count}
      </span>
    </button>
  );
}
